
<div *ngIf="area !== 'unable-to-cancel'"class="joi-dialog payment">

  <div  mat-dialog-title [class]="'mat-dialog-title '+paymentState?.header_class">
      <icon class="mobile" (click)="emitClose()" matIcon="close"></icon>
      <span>{{ paymentState?.header_title}}</span>
  </div>
<div mat-dialog-content>
     <div class="area" [ngClass]="{showing:area === 'cancel'}">
      <div *ngIf="!docket?.tally || docket?.tally === 0">
        <div class="para">We&rsquo;re sorry to see you go! Thanks for using Joi :)</div>
        <div class="para">Without a subscription you will not be able to create events in the account <strong>{{ account?.title }}</strong>. You can continue to use Joi if you&rsquo;ve been added to the workforce of an event in a different account &ndash; that&rsquo;s always free!</div>
        <div class="para"><strong>Note:</strong> if you or another administrator of the account <strong>{{ account?.title }}</strong> don&rsquo;t log in for 365 days, the account and all associated events will be deleted. This cannot be undone. Don&rsquo;t worry&ndash;we&rsquo;ll email you before this happens to give you a chance to keep your data.</div>
        <div class="para"><strong>Are you sure you want to cancel your subscription?</strong></div>
      </div>
    </div>
    <div class="area" [ngClass]="{showing:area === 'subscription'}">
      <div class="subscription_header" [ngClass]="{has_existing_subscription:docket?.stripeId}">
        <mat-select class="country" (selectionChange)="updateCountry()" [(ngModel)]="current_country">
          <mat-select-trigger>
            {{ display_country }}
          </mat-select-trigger>
          <mat-option *ngFor="let country of available_countries" [value]="country.code">
            {{ country.name }}
          </mat-option>
        </mat-select>
        <mat-select (selectionChange)="updateCurrency()" [(ngModel)]="selected_currency">
          <mat-select-trigger>
            {{ selected_currency }}
          </mat-select-trigger>
          <mat-option *ngFor="let currency of accountService.currencies" [value]="currency" >
            {{ currency }}
          </mat-option>
        </mat-select>
      </div>
      <div class="current_summary">
        <div>
          <h5 class="small_title">Current subscription:</h5>
          <div *ngIf="docket?.stripePlanId">
            {{ accountService.plans.quantities[current_quantity_idx] }} active events billed {{ intervally[current_interval] }}
          </div>
          <div *ngIf="!docket?.stripePlanId && !docket?.days_remaining"><b>Free trial pending</b></div>
          <div *ngIf="!docket?.stripePlanId && !!docket?.days_remaining && docket?.days_remaining?.charAt(0) !== '-'"><b>Free trial</b> ({{ docket?.days_remaining }} day{{ docket?.days_remaining === '1' ? '' : 's'}} left)</div>
          <div *ngIf="!docket?.stripePlanId && !!docket?.days_remaining && docket?.days_remaining?.charAt(0) === '-'"><b>Trial has expired</b></div>
        </div>
        <div>
          <h5 class="small_title">Current usage:</h5>
          <div>{{ docket?.tally || 0}} active events</div>
        </div>
      </div>
      <div>
        <div><b>Select your subscription level for <em>{{ account?.title }}</em>:</b></div>
        <h5 class="small_title">Active events</h5>
      </div>
      <div class="selected_pointer">
        <div *ngFor="let quantity of accountService.plans.quantities; index as index" [ngClass]="{selected:index === current_quantity_idx}"></div>
        <div class="more"></div>
      </div>
      <mat-button-toggle-group #group="matButtonToggleGroup"
          [(ngModel)]="selected_quantity_idx">
        <mat-button-toggle
          *ngFor="let quantity of accountService.plans.quantities; index as index"
          [value]="index" color="primary"
          [ngClass]="{selected:index === current_quantity_idx,disabled:quantity < docket?.tally}"
          (click)="showIneligibleMessage(quantity < docket?.tally, quantity)"
        >
          {{ quantity }}
        </mat-button-toggle>
        <mat-button-toggle value="-1" (click)="showIneligibleMessage(false, 0)">
          {{ accountService.plans.quantities[accountService.plans.quantities.length - 1] + 1 }}+
        </mat-button-toggle>
      </mat-button-toggle-group>
      <div class="ineligible">
        <div *ngIf="ineligible_message_should_show">
          Close or delete
          {{ docket?.tally - ineligible_message_should_show }}
          event{{ docket?.tally - ineligible_message_should_show === 1 ? '':'s' }} before selecting this subscription
        </div>
        <div *ngIf="current_plan_unsupported">
          The plan you are currently on is no longer offered.
        </div>
      </div>
      <div *ngIf="needs_more_active_events">
        <div *ngIf='!contact_us_submitted' class="contact_us_form">
          <div class="instructions">
            <h3>Wow! That's a lot of events.</h3>
            <br /><br />
            Consider splitting your events across multiple accounts for better organisational control (for example, one account for your marketing events and another for your internal training events).
            <br /><br />
            Want to talk about enterprise options?


            </div>
          <button mat-button color="primary" (click)="openContactUsURL()">Contact Us</button>
          <!-- <div class="form">
              <mat-form-field class="general">
                  <input matInput  name="name" placeholder="Name" [(ngModel)]="contact_us.name" />
              </mat-form-field>
              <mat-form-field class="general">
                  <input matInput name="email" placeholder="Email address" [(ngModel)]="contact_us.email" type="email" />
              </mat-form-field>
              <mat-form-field class="general">
                  <input matInput name="phone" placeholder="Phone number" [(ngModel)]="contact_us.phone" type="tel" />
              </mat-form-field>
            <button [disabled]="!contact_us.name || !contact_us.email || !contact_us.phone" (click)="submitContactUs()" class="primary">Submit</button>
          </div> -->
        </div>
      </div>
      <div *ngIf="!needs_more_active_events">
        <div
          *ngFor="let interval of accountService.plans.intervals"
          (click)="updateInterval(interval)"
          class="plan item">
          <div class="border" [ngClass]="{standard:docket?.linked}">
            <div class="subscription_label">
              {{interval_labels[(docket?.linked ? 'standard' : 'normal')]}}{{interval_labels[interval]}}
              <span class="savings" *ngIf="summary[interval].monthly_savings">(save {{summary[interval].monthly_savings | currency:selected_currency: 'symbol-narrow' : '1.2'}}/month!)</span>
            </div>
            <div class="costings">
                <div class="cost">
                    <span class="sup">{{selected_currency}} </span>
                    <span class="mid">{{summary[interval].standard_monthly_cost | currency:selected_currency: 'symbol-narrow' : '1.2'}}</span>
                    <span class="sub">/MONTH</span>
                </div>
                <div class="gst"><span *ngIf="current_country == 'AU'">(incl. GST)</span></div>
            </div>
          </div>
        </div>

        <div *ngIf="docket?.linked && link_info" class="linked plan item">
          <div class="subscription_label">Your discounted subscription:</div>
          <div class="costings">
              <div class="cost">
                  <span class="sup">{{selected_currency}} </span>
                  <span class="mid">{{summary[selected_interval].monthly_cost | currency:selected_currency: 'symbol-narrow' : '1.2'}}</span>
                  <span class="sub">/MONTH</span>
              </div>
              <div class="gst"><span *ngIf="current_country == 'AU'">(incl. GST)</span></div>
              <div class="discounted_savings" *ngIf="summary[selected_interval].standard_monthly_savings > 0">You save {{ summary[selected_interval].standard_monthly_savings | currency:selected_currency: 'symbol-narrow' : '1.2' }}/month!</div>
          </div>
          <div class="linked_explanation">
            Note: Your <strong>{{ link_info.accounts.length }} linked accounts</strong> will be subscribed to a total of <strong>{{ link_info.sum }} events</strong>, putting you in the <strong>{{ linked_tier }} active events</strong> pricing tier. Your monthly subscription cost may change if linked accounts adjust their subscription level, unlink their accounts or new accounts are linked.
          </div>
        </div>
      </div>
      <div class="cancel_button" (click)="confirmCancelSubscription()" *ngIf="docket?.stripeSubscriptionId">
        Cancel subscription
      </div>
    </div>
    <div class="area" [ngClass]="{showing:area === 'request_sent'}">
      <div class="thank_you">Contact request submitted</div>
      <div>We will get back to you</div>
    </div>
    <div class="area" [ngClass]="{showing:area == 'storage'}">
      <!-- Here are all the storage options -->
    </div>
    <div class="area summary" [ngClass]="{showing:area == 'summary'}">
      <div class="title">Summary:</div>
      <div class="line_items">
        <div class="proration line_item" *ngIf="upcoming_invoice_loading">
          <div class="line">Calculating proration</div>
          <div class="item"><mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner></div>
        </div>
        <div class="line_item" *ngFor="let li of lineitems">
          <div class="line">{{li.line}}<span class="bold">{{li.code}}</span></div>
          <div class="item" [ngClass]="{bold:li.type == 'promo'}">{{li.type != 'promo' ? (li.item | currency:selected_currency: 'symbol-narrow' : '1.2') : li.item | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
        </div>
      </div>
      <hr />
      <div class="line_items">
        <div class="line_item" *ngFor="let li of sublineitems">
          <div class="line">{{li.line}}<span class="bold">{{li.code}}</span>{{li.code_name}}</div>
          <div class="item">{{li.item | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
        </div>
      </div>
      <div class="total">
        <div class="line">Today's total:</div>
        <div class="item"><span class="sup">{{selected_currency}} </span>{{ selected_total | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
      </div>
      <div class="promocode_area">
        <div *ngIf="!paymentState?.show_promo_input && !promocode_obj" class='text_link' (click)="displayPromoCodeInput()">+ Add promo code</div>
        <div *ngIf="!paymentState?.show_promo_input && promocode_obj" class='text_link grey' (click)="removePromoAppliedCode()">Remove promo code</div>
        <div *ngIf="paymentState?.show_promo_input">
          <mat-form-field>
            <input matInput #promoInput id="promocode" name="promocode" [(ngModel)]="promocode" placeholder="Promo code" />
          </mat-form-field>
        </div>
        <button mat-button *ngIf="paymentState?.show_promo_input" color="primary" (click)="applyPromoCode()" [disabled]="!promocode || promocode === invalid_promocode">Apply</button>
        <div class="promo_error">{{promo_error}}</div>
      </div>
    </div>
    <div class="area downgrade" [ngClass]="{showing:area == 'downgrade'}" >
      <div class="title">Summary:</div>
      <div class="line_items">
        <div class="line_item" *ngFor="let li of lineitems">
          <div class="line">{{li.line}}<span class="bold">{{li.code}}</span></div>
          <div class="item">{{li.item | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
        </div>
      </div>
      <hr />
      <div class="line_items">
        <div class="line_item" *ngFor="let li of sublineitems">
          <div class="line">{{li.line}}<span class="bold">{{li.code}}</span>{{li.code_name}}</div>
          <div class="item">{{li.item | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
        </div>
      </div>
      <div class="total">
        <div class="line">Next invoice's total:</div>
        <div class="item"><span class="sup">{{selected_currency}} </span>{{ selected_total | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
      </div>
      <div class="grey" *ngIf="selected_total < 0">Negative balances will be applied to future invoices.</div>
      <div class="promocode_area">
        <div *ngIf="!paymentState?.show_promo_input && !promocode_obj" class='text_link' (click)="displayPromoCodeInput()">+ Add promo code</div>
        <div *ngIf="!paymentState?.show_promo_input && promocode_obj" class='text_link grey' (click)="removePromoAppliedCode()">Remove promo code</div>
        <div *ngIf="paymentState?.show_promo_input">
          <mat-form-field>
            <input matInput #promoInput id="promocode" name="promocode" [(ngModel)]="promocode" placeholder="Promo code" />
          </mat-form-field>
        </div>
        <button *ngIf="paymentState?.show_promo_input" class="primary" (click)="applyPromoCode()" [disabled]="!promocode || promocode === invalid_promocode">Apply</button>
        <div class="promo_error">{{promo_error}}</div>
      </div>
    </div>
    <div class="area upcoming" [ngClass]="{showing:area == 'upcoming'}">
      <div class="title">Summary:</div>
      <div class="line_items">
        <div class="proration line_item" *ngIf="!upcoming_invoice">
          <div class="line">Calculating proration...</div>
          <div class="item"><mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner></div>
        </div>
        <div class="line_item" *ngFor="let li of lineitems">
          <div class="line">{{li.line}}<span class="bold">{{li.code}}</span></div>
          <div class="item">{{li.item | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
        </div>
      </div>
      <hr />
      <div class="line_items">
        <div class="line_item" *ngFor="let li of sublineitems">
          <div class="line">{{li.line}}<span class="bold">{{li.code}}</span>{{li.code_name}}</div>
          <div class="item">{{li.item | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
        </div>
      </div>
      <div class="total">
        <div class="line">Today's total:</div>
        <div class="item"><span class="sup">{{selected_currency}} </span>{{ selected_total | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
      </div>
      <div class="grey" *ngIf="selected_total < 0">Negative balances will be applied to future invoices.</div>
      <div class="promocode_area">
        <div *ngIf="!paymentState?.show_promo_input && !promocode_obj" class='text_link' (click)="displayPromoCodeInput()">+ Add promo code</div>
        <div *ngIf="!paymentState?.show_promo_input && promocode_obj" class='text_link grey' (click)="removePromoAppliedCode()">Remove promo code</div>
        <div *ngIf="paymentState?.show_promo_input">
          <mat-form-field>
            <input matInput #promoInput id="promocode" name="promocode" [(ngModel)]="promocode" placeholder="Promo code" />
          </mat-form-field>
        </div>
        <button *ngIf="paymentState?.show_promo_input" class="primary" (click)="applyPromoCode()" [disabled]="!promocode || promocode === invalid_promocode">Apply</button>
        <div class="promo_error">{{promo_error}}</div>
      </div>
    </div>
    <div class="area method" [ngClass]="{showing:area == 'method'}">
      <div class="title">Billing Information:</div>
      <div id="list"></div>
      <form #paymentForm class="form">
        <div *ngIf="!one_off">
          <label for="invoiceName">Name on invoice</label>
          <mat-form-field class="general">
            <input matInput name='invoiceName' [(ngModel)]="invoiceName" required />
          </mat-form-field>
        </div>
        <div *ngIf="!show_current_methods || one_off">
          <label for="cardName">Name on card</label>
          <mat-form-field class="general">
              <input matInput  name='cardName' [(ngModel)]="cardName" required />
          </mat-form-field>
        </div>
        <div class="form-row">
          <div *ngIf="show_current_methods && !one_off" class="saved_methods">
            <div class="plan item" *ngFor="let method of docket?.methods; index as index" >
              <div class="border card">
                <div>
                  {{ method.brand }}
                </div>
                <div>
                  &nbsp;
                  &bull;&bull;&bull;&bull;&nbsp;
                  &bull;&bull;&bull;&bull;&nbsp;
                  &bull;&bull;&bull;&bull;&nbsp;
                  {{ method.last4 }}
                </div>
                <div>
                  exp: {{ method.exp_month > 9 ? method.exp_month : '0'+method.exp_month }}/{{ method.exp_year}}
                </div>
              </div>
              <div class="current_indicator" *ngIf="index === active_method_index">
                <div class="indicator">CURRENT PAYMENT METHOD</div>
              </div>
            </div>
          </div>
          <div class="showable" [ngClass]="{showing:!show_current_methods || one_off}">
            <label for="card-element">
              Pay with Credit or Debit Card
            </label>
            <div class="input" id="card-element">
              <!-- A Stripe Element will be inserted here. -->
            </div>
            <!-- Used to display form errors. -->
            <div #errorElement id="card-errors" role="alert"></div>
          </div>
          <div class="text_link method_toggle"
            *ngIf="docket?.methods?.length > 0 && !one_off"
            (click)="toggleShowMethods()">{{ !show_current_methods ? "Use saved payment method" : "Replace existing payment method" }}</div>
          <div class="fineprint">
            This card will be saved to your account to enable subscription payments.
            You can cancel your subscription at any time from your account.
            Renewal rates are subject to change, but we will always notify you of any rate changes beforehand.
          </div>
          <div class="terms_check">
            <mat-checkbox color="primary" value="true" name="have_read_terms" [(ngModel)]="have_read_terms" required></mat-checkbox>
            <div class="terms_label" (click)="termsClick($event)">
              I have read and agree to the <span class="text_link">End User License Agreement</span> and authorise payments.
            </div>
          </div>
          <div *ngIf="!one_off">
            <hr />
            <div class="total">
              <div class="line">Today's total:</div>
              <div class="item"><span class="sup">{{selected_currency}} </span>{{ selected_total | currency:selected_currency: 'symbol-narrow' : '1.2'}}</div>
            </div>
          </div>
        </div>

      </form>
    </div>
    <div class="area complete" [ngClass]="{showing:area == 'complete'}">
      <div class="title">Thanks for subscribing to Joi!</div>
      <div class="para">Your new subscription level gives you access to up to {{ next_quantity }} active events.<br />You can change this at any time.</div>
      <div *ngIf="next_payment_due">Next payment due on {{ next_payment_due | date }}.</div>
    </div>
    <div class="area pending" [ngClass]="{showing:area == 'pending'}">
      <div class="title">Joi subscription pending.</div>
      <div>Your subscription will be finalised when we receive approval from your credit card company.</div>
    </div>
    <div class="area method_complete" [ngClass]="{showing:area == 'method_complete'}">
      <div class="title">Success!</div>
      <div class="para">Your payment method has been updated.</div>
      <div *ngIf="next_payment_due">Next payment due on {{ next_payment_due | date }}.</div>
    </div>
    <div class="area cancel_complete" [ngClass]="{showing:area == 'cancel_complete'}">
      <div class="title">Subscription has been cancelled.</div>
      <div class="para">Your subscription has been cancelled successfully.</div>
    </div>
  </div>
  <mat-progress-bar mode="indeterminate" *ngIf="is_loading"></mat-progress-bar>
  <div mat-dialog-actions id="action">
    <button *ngIf="paymentState?.btn_prev" mat-button (click)="previous()" [disabled]="area === 'subscription' || is_loading">PREVIOUS</button>
    <div style="flex-grow:1;"></div>
    <button mat-button (click)="emitClose()" [disabled]="is_loading" *ngIf="paymentState?.btn_cancel"><span *ngIf="paymentState?.btn_dont">DON'T </span><span>CANCEL</span></button>
    <button mat-button (click)="emitClose(true)"*ngIf="paymentState?.btn_close">CLOSE</button>
    <button mat-button color="primary"
      *ngIf="paymentState?.btn_next"
      [disabled]="!selected_plan || selected_plan.quantity === current_plan.quantity || ineligible_message_should_show > 0 || (paymentState?.show_promo_input && promocode !== '' && !promocode_obj) || contact_us_submitted"
      (click)="proceed()">NEXT</button>
    <button mat-button color="primary"
      *ngIf="paymentState?.btn_cta"
      [disabled]="!have_read_terms || !cardName || !invoiceName || is_loading || needs_more_active_events || (!cc_info_complete && !show_current_methods)"
      (click)="save()">{{one_off ? 'SAVE' : 'PAY NOW'}}</button>
    <button mat-button color="primary"
      *ngIf="paymentState?.btn_update"
      (click)="save()">UPDATE SUBSCRIPTION</button>
    <button mat-button color="warn"
      *ngIf="area === 'cancel' && docket?.tally === 0"
      (click)="cancelSubscription()">REMOVE SUBSCRIPTION NOW</button>
    <button mat-button color="primary"
      *ngIf="paymentState?.btn_got_it"
      (click)="previous()">GOT IT</button>
  </div>
</div>

<!-- Dialog without bottom area, instead only has an "X" in top right to close.  Could definitely clean up the *ngIf if we mean to add more like this -->
<div *ngIf="area === 'unable-to-cancel'" class="joi-dialog payment">
  <div mat-dialog-title [class]="'mat-dialog-title '+paymentState?.header_class">
    <span>{{ paymentState?.header_title}}</span>
    <icon (click)="previous()" class="right-close" mat-button color="primary" matIcon="close"></icon>
  </div>
  <div mat-dialog-content class="no-bottom">
    <div class="area" [ngClass]="{showing:area === 'unable-to-cancel'}">

      <div class="para">It looks like you still have <strong>{{ docket?.tally === 1 ? '1 active event' : docket?.tally+' active events' }}.</strong></div>
      <div class="para">Before cancelling your subscription you will need to close or delete any active events.</div>
    </div>
  </div>
</div>
